module.exports = __webpack_public_path__ + "static/media/april-international-logo-vector-2024.eb24f4c0.svg";